export default (to, from, next) => {
  if (localStorage.getItem(process.env.VUE_APP_TOKEN_NAME) && localStorage.getItem(process.env.VUE_APP_TOKEN_NAME).length > 0) {
    next();
  } else {
    localStorage.removeItem(process.env.VUE_APP_TOKEN_NAME);
    localStorage.setItem('redirect_url', to.fullPath);
    next('/auth');
  }
};
